// Application configuration from environment variables and runtime config
// Runtime config (from window.__APP_CONFIG__) takes precedence over build-time env vars

const getRuntimeConfig = () => {
  if (typeof window !== 'undefined' && window.__APP_CONFIG__) {
    return window.__APP_CONFIG__;
  }
  return {};
};

/**
 * Priority: DEV `/api` proxy > explicit window.__APP_CONFIG__.apiBaseUrl > VITE_API_BASE_URL > live default
 */
export const getApiBaseUrl = () => {
  if (import.meta.env.DEV) {
    return '/api';
  }

  const runtimeConfig = getRuntimeConfig();
  if (runtimeConfig.apiBaseUrl) {
    return runtimeConfig.apiBaseUrl;
  }

  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  return 'https://api.celszc.org/api';
};

export const getApiBaseUrlWithoutApi = () => {
  const baseUrl = getApiBaseUrl();
  return baseUrl.replace(/\/api\/?$/, '');
};

/**
 * KingsChat OAuth start URL (API redirects to accounts.kingsch.at).
 */
export const getKingsChatLoginUrl = (redirect = '') => {
  const base = getApiBaseUrl().replace(/\/$/, '');
  const path = '/auth/kingschat';
  if (redirect) {
    return `${base}${path}?redirect=${encodeURIComponent(redirect)}`;
  }
  return `${base}${path}`;
};

export const API_BASE_URL = getApiBaseUrl();
export const API_BASE_URL_WITHOUT_API = getApiBaseUrlWithoutApi();

/** Role home paths — see also lib/access.js ROLE_HOME */
export { roleHomePath } from './access';
